import {DeleteOutlined} from '@ant-design/icons';
import {Button, Form, Input, Tooltip} from 'antd';
import React, {forwardRef, useImperativeHandle} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';
import {IGroupCompanyOperations, IGroupCompanyConditionsProps} from 'pages/ais/organization-structure-v5/model/types';

import styles from './dependent-part-list-item.module.less';

export const DependentPartConditions = forwardRef<IGroupCompanyOperations, IGroupCompanyConditionsProps>(
    ({conditionsFields, conditionsListOperations, setFieldsCount}: IGroupCompanyConditionsProps, ref) => {
        const {add, remove} = conditionsListOperations;

        useImperativeHandle(ref, () => ({add, remove}));

        return (
            <>
                {conditionsFields.map((conditionField) => (
                    <section
                        className={styles['dependent-part-list__condition-row']}
                        key={conditionField.name}
                    >
                        <Form.Item
                            rules={[{required: true}]}
                            label="Вид участия в капитале"
                            name={[conditionField.name, 'partType']}
                            className={styles['dependent-part-list__condition-row--width']}
                        >
                            <CustomSelect
                                settings={{
                                    url: 'valueLists/FLEX_VALUE?sublistCode=part_type',
                                    valuePath: 'id',
                                    labelPath: 'description',
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Доля участия в капитале"
                            rules={[{required: true}]}
                            name={[conditionField.name, 'shareParent']}
                            className={styles['dependent-part-list__share-parent--width']}
                        >
                            <Input
                                onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>
                        <Form.Item label={<>&nbsp;</>}>
                            <Tooltip
                                title="Удалить условие"
                                placement="right"
                                mouseEnterDelay={0.8}
                            >
                                <Button
                                    type="default"
                                    className="btn-only-icon"
                                    onClick={() => {
                                        remove(conditionField.name);
                                        setFieldsCount((prevCount) => (prevCount ?? 1) - 1);
                                    }}
                                >
                                    <DeleteOutlined />
                                </Button>
                            </Tooltip>
                        </Form.Item>
                    </section>
                ))}
            </>
        );
    }
);
